import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import cx from 'classnames';
import styles from './style.css';

const Notif = ({ text, type }) => {
  const msgType = cx({
    [styles.error]: type === 'error',
    [styles.success]: type === 'success',
  });

  return (
    <div className={msgType}>
      <p>{text}.</p>
    </div>
  );
};

Notif.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default observer(Notif);



// WEBPACK FOOTER //
// ./src/components/notif/index.js